/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import Menu from "@modules/MenuModule"
import BannerModule from "@modules/BannerModule"

import { Provider } from "@context/LanguageContext"

import { useBreakpoints } from "@hooks/useBreakpoints"

import Footer from "@modules/FooterModule"
//const Footer = React.lazy(() => import("@modules/FooterModule"))
import SEO from "./SEO"

const Layout = ({
  children,
  pageContext,
  theme,
  getStartedEvent,
  footerEventId,
  pageLocation,
  html = null,
  outsideCookiesPolicy = false,
}) => {
  const [isCollapse, setCollapse] = useState(true)
  let background
  switch (theme) {
    case "white-bg":
      background = "bg-white"
      break
    case "gray-bg":
      background = "bg-lblue"
      break
    case "lblue-bg":
      background = "bg-lblue"
      break
    default:
      background = "bg-dblue"
  }

  const { isTablet } = useBreakpoints()

  const brightness = isTablet && !isCollapse ? "!brightness-50" : ""

  /* Store UTM source in session storage */
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const utm_source = params.get("utm_source")

    if (utm_source) {
      sessionStorage.setItem("utm_source", utm_source)
    }
  }
  return (
    <Provider
      value={{
        language: pageContext.language,
        theme: theme,
        availableLanguages: pageContext.availableLanguages,
        context: pageContext,
      }}
    >
      <SEO
        pageContext={pageContext}
        html={html}
        outsideCookiesPolicy={outsideCookiesPolicy}
      />
      <div className={`w-full ${background} 	 `}>
        <Menu
          theme={theme}
          isCollapse={isCollapse}
          setCollapse={setCollapse}
          getStartedEvent={getStartedEvent}
        />
        <main className={`pt-[70px] desk:pt-25 ${brightness}`}>
          <BannerModule theme={theme} pageLocation={pageLocation} inverted />
          {children}
        </main>{" "}
        <div className={`w-full bg-white ${brightness}`}>
          <Footer footerEventId={footerEventId} />
        </div>
      </div>
    </Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  theme: "blue-bg",
}

export default Layout
